import axios from 'axios';
import config from '../../../config';

const baseUrl = config.baseUrl;
const Endpoint = '/api/getVisitastecnicas';

// Crear una instancia de Axios para configurar base URL y otras opciones
const api = axios.create({
    baseURL: config.baseUrl,
});


const getVisitasTecnicas = async (email) => {
    try {
        const response = await api.get(`${baseUrl}${Endpoint}?email=${email}`);
        return {
            status: response.status,
            data: response.data.visitas_tecnicas,
            total_participantes: response.data.total_participantes

        };
    } catch (error) {
        console.error('Error fetching visitas técnicas:', error);
        return {
            status: error.response ? error.response.status : 500,
            message: 'Error fetching visitas técnicas'
        };
    }
};

export default getVisitasTecnicas;